import React from "react"
import { Divider } from "@chakra-ui/react"
import PreviewCard from "./PreviewCard"

const Spacer = () => (
  <PreviewCard>
    <Divider h={4} />
  </PreviewCard>
)

export default Spacer
